import axios from 'axios'
// import { useAuthStore } from '@/store/auth'

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'https://api.roiq.com/1.0/'
})

// instance.interceptors.request.use(config => {
//   const auth = useAuthStore()
//   if (auth.token) config.headers.Authorization = `Bearer ${auth.token}`
//   return config
// })

export default instance
